class VgRecaptcha {
    constructor(siteKey) {
        this.siteKey = siteKey;
    }

    /**
     * Generates a reCAPTCHA token.
     * @returns {Promise<string|null>} reCAPTCHA token
     */
    async generateToken() {
        try {
            return await grecaptcha.enterprise.execute(this.siteKey, { action: "submit_form" });
        } catch (error) {
            console.error("ReCAPTCHA token generation failed:", error);
            return null;
        }
    }

    /**
     * Adds the reCAPTCHA token to the form as a hidden input.
     * @param {HTMLElement} form The form element
     * @param {string} token The generated reCAPTCHA token
     */
    static addTokenToForm(form, token) {
        if (!form) {
            console.warn("Form not found.");
            return;
        }

        let recaptchaInput = form.querySelector("input[name='g-recaptcha-response']");
        if (!recaptchaInput) {
            recaptchaInput = document.createElement("input");
            recaptchaInput.type = "hidden";
            recaptchaInput.name = "g-recaptcha-response";
            form.appendChild(recaptchaInput);
        }
        recaptchaInput.value = token;
        console.log("ReCAPTCHA Token Added:", token);
    }

    /**
     * Sends the reCAPTCHA token to the backend for verification.
     * @param {string} token The generated reCAPTCHA token
     * @returns {Promise<Object>} Validation response from API
     */
    static async validateToken(token) {
        try {
            const api = new VgApiClient(VgHelpers.getCountry(), VgHelpers.getLanguage());
            return await api.validateRecaptcha(token);
        } catch (error) {
            console.error("Error verifying reCAPTCHA:", error);
            return { error: true };
        }
    }

    /**
     * Generates, adds, and validates reCAPTCHA in one function.
     * @param {HTMLElement} form The form element
     * @returns {Promise<Object>} Validation response from API
     */
    static async generateAndValidateRecaptcha(form) {
        if (!form) {
            console.warn("Form is missing.");
            return { error: true };
        }

        // Generate a new reCAPTCHA token
        const token = await grecaptcha.enterprise.execute(vgRecaptcha.siteKey, { action: "submit_form" });

        if (!token) {
            console.error("Failed to generate reCAPTCHA token.");
            return { error: true };
        }

        // Add token to form
        this.addTokenToForm(form, token);

        // Validate token on backend
        return await this.validateToken(token);
    }
}
